// Blog posts data structure
export const blogPosts = [
  {
    id: 1,
    type: 'news',
    title: "Brainy AI v1.0 is Now Live!",
    summary: "We're excited to announce that Brainy AI v1.0 is officially available to everyone",
    content: `
      <p>Today marks a milestone moment for us at Brainy AI – version 1.0 is now officially live!</p>
      
      <h3>What's Included in v1.0:</h3>
      <ul>
        <li><strong>AI-Powered Learning Roadmaps:</strong> Get personalized learning paths tailored to your goals</li>
        <li><strong>Interactive AI Lessons:</strong> Engage with AI-generated lessons that adapt to your pace</li>
        <li><strong>Knowledge Assessment:</strong> Test your understanding and track your progress</li>
        <li><strong>Intelligent Chat Assistant:</strong> Get instant help whenever you need it</li>
        <li><strong>Pomodoro Timer:</strong> Built-in focus tools to maximize productivity</li>
        <li><strong>Goal Management:</strong> Set, track, and achieve your learning objectives</li>
      </ul>
      
      <p>Whether you're a student, professional, or lifelong learner, Brainy AI is here to make your learning journey more effective and enjoyable.</p>
      
      <h3>Get Started Today</h3>
      <p>Sign up now and start your personalized learning journey. Free tier includes everything you need to get started, and Pro plans unlock unlimited access to all AI features.</p>
      
      <p>Thank you for being part of our journey. Let's learn smarter, together! 🎉</p>
    `,
    date: '2025-10-11',
    formattedDate: 'October 11, 2025',
    readTime: 2,
    author: {
      name: 'Brainy AI Team',
      avatar: '/logo.png'
    }
  }
];

// Get posts by type
export const getArticles = () => blogPosts.filter(post => post.type === 'article');
export const getNews = () => blogPosts.filter(post => post.type === 'news');
export const getRecentPosts = (count = 3) => blogPosts.slice(0, count);
export const getPostById = (id) => blogPosts.find(post => post.id === parseInt(id));

// Get related posts (excluding current post)
export const getRelatedPosts = (currentPostId, count = 3) => {
  return blogPosts
    .filter(post => post.id !== currentPostId)
    .slice(0, count);
};

